import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import _typeof from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/typeof";
import cookie from './cookie';
import env from './env';
import { createNormalizer } from './urlFactory';

function getUin(uinStr) {
  var ret = '';

  if (uinStr) {
    var reg = /^o0*/g;

    if (reg.test(uinStr)) {
      ret = parseInt(uinStr.replace(/^o0*/g, ''), 10);
    } else {
      ret = uinStr;
    }
  }

  return ret;
}

function getUserid() {
  // 根据用户id缓存信息
  var accountType = cookie.get('main_login');
  var uid = '';

  if (accountType === 'wx') {
    uid = cookie.get('openid');
  } else if (accountType === 'qq') {
    uid = cookie.get('uin') || cookie.get('luin');
    uid = getUin(uid);
  }

  return uid;
}
/**
 * 删除参数值
 *
 * @param {string} url
 * @param {string|array} ref
 *
 * @return {string}
 */


export function delQueStr(url, ref) {
  var str = '';

  if (url.indexOf('?') !== -1) {
    str = url.substr(url.indexOf('?') + 1);
  } else {
    return url;
  }

  var arr = '';
  var returnurl = ''; // const setparam = "";

  var isHit = Object.prototype.toString.call(ref) === '[object Array]' ? function (v) {
    return ~ref.indexOf(v);
  } : function (v) {
    return v === ref;
  };

  if (str.indexOf('&') !== -1) {
    arr = str.split('&');

    for (var i = 0, len = arr.length; i < len; i++) {
      if (!isHit(arr[i].split('=')[0])) {
        returnurl = "".concat(returnurl + arr[i].split('=')[0], "=").concat(arr[i].split('=')[1], "&");
      }
    }

    return returnurl ? "".concat(url.substr(0, url.indexOf('?')), "?").concat(returnurl.substr(0, returnurl.length - 1)) : url.substr(0, url.indexOf('?'));
  } else {
    arr = str.split('=');

    if (isHit(arr[0])) {
      return url.substr(0, url.indexOf('?'));
    } else {
      return url;
    }
  }
}
/**
 * 从URL中获取指定的参数值
 *
 * @param {String}
 *          p url参数
 * @param {String}
 *          u url 默认为当前url，可为空，如果传入该变量，将从该变量中查找参数p
 * @return {String} 返回的参数值
 */

export function getUrlParam(p, u) {
  u = u || location.href;
  var reg = new RegExp("[?&#]".concat(p, "=([^&#]+)"), 'gi');
  var matches = u.match(reg);
  var strArr;

  if (matches && matches.length > 0) {
    strArr = matches[matches.length - 1].split('=');

    if (strArr && strArr.length > 1) {
      // 过滤XSS字符
      return filterXSS(strArr[1]);
    }

    return '';
  }

  return '';
}
/**
 *获取专辑角标url
 * @param imgTag：角标字段，一般取的是aphone40_imgtag字段，或返回格式同aphone40_imgtag字段
 * @returns {string} 要展示的角标url
 */

export function getCoverTag(imgTag) {
  var normalizer = createNormalizer();

  function format(tpl, data) {
    return tpl.replace(/\{(\w+)\}/g, function (m, w) {
      var val = data[w] || '';

      if (val.indexOf(';') != -1) {
        var _tags = val.split(';');

        if (_tags.length >= 2 && _tags[1]) {
          val = _tags[1];
        }
      }

      if (val.indexOf("=") != -1) {
        var varArr = val.split("=");

        if (varArr.length > 0 && varArr[1]) {
          val = varArr[1];
        }
      }

      return /^(http:|https:|\/\/)/.test(val) ? normalizer(val, false, 'https') : val;
    });
  }

  function legalParam(paramText) {
    if (/\.(\w+)$/.test(paramText)) {
      return true;
    }

    return false;
  }

  function indexOf(item, arr) {
    for (var i = 0; i < arr.length; i++) {
      if (item === arr[i]) return i;
    }

    return -1;
  }

  var str = '',
      positions = [2],
      tag = imgTag;

  if (tag) {
    var tag2Tpl = "<img src=\"{param2}\" alt=\"{text}\">"; // 先对tag进行处理，若为string类型的json则转换

    if (typeof tag === "string") {
      try {
        tag = JSON.parse(tag);
      } catch (e) {
        /* do nothing */
      }
    } // 出品类型：独播，腾讯出版


    if (tag.tag_2 && tag.tag_2.id > 0 && indexOf(2, positions) != -1) {
      if (legalParam(tag.tag_2["param2"])) {
        str += format(tag2Tpl, tag.tag_2);
      }
    }
  }

  return str;
}
/**
 * 设置url中指定的参数
 *
 * @param {string}
 *          name [参数名]
 * @param {string}
 *          value [参数值]
 * @param {string}
 *          url [发生替换的url地址|默认为location.href]
 * @return {string} [返回处理后的url]
 */

export function setUrlParam(name, value, url) {
  url = url || location.href;
  var reg = new RegExp("[?&#]".concat(name, "=([^&#]*)"), 'gi');
  var matches = url.match(reg);
  var key = "{key".concat(new Date().getTime(), "}");
  var strArr;

  if (matches && matches.length > 0) {
    strArr = matches[matches.length - 1];
  } else {
    strArr = '';
  }

  var extra = "".concat(name, "=").concat(value); // 当原url中含有要替换的属性:value不为空时，仅对值做替换,为空时，直接把参数删除掉

  if (strArr) {
    var first = strArr.charAt(0);
    url = url.replace(strArr, key);
    url = url.replace(key, value ? first + extra : '');
  } else if (value) {
    // 当原url中不含有要替换的属性且value值不为空时,直接在url后面添加参数字符串
    if (url.indexOf('?') > -1) {
      url += "&".concat(extra);
    } else {
      url += "?".concat(extra);
    }
  } // 其它情况直接返回原url


  return url;
}
/**
 * 过滤XSS
 *
 * @param {string}
 *          str
 * @return {}
 */

export function filterXSS(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}
export default {
  getUrlParam: getUrlParam,
  setUrlParam: setUrlParam,
  delQueStr: delQueStr,
  getCoverTag: getCoverTag,

  /**
   * 检测是否公司域名
   *
   * @param {string}
   *          sUrl
   * @return {}
   */
  vaildURL: function vaildURL(sUrl) {
    return !!(/^(https?:\/\/)?[\w\-.]+\.(qq|paipai|soso)\.com($|\/|\\)/i.test(sUrl) || /^[\w][\w/.\-_%]+$/i.test(sUrl) || /^[/\\][^/\\]/i.test(sUrl));
  },
  filterXSS: filterXSS,

  /**
   * 接下来要用到的正则
   */

  /* eslint camelcase: ["error", {properties: "never"}] */
  RegExps: {
    nl2br: /\n/g,
    s2nb: /[\x20]{2}/g,
    escHTML: {
      re_amp: /&/g,
      re_lt: /</g,
      re_gt: />/g,
      re_apos: /\x27/g,
      re_quot: /\x22/g
    },
    restHTML: {
      re_amp: /&amp;/g,
      re_lt: /&lt;/g,
      re_gt: /&gt;/g,
      re_apos: /&(?:apos|#0?39);/g,
      re_quot: /&quot;/g
    }
  },

  /**
   * 通用替换
   *
   * @ignore
   * @param {string} s 需要进行替换的字符串
   * @param {String/RegExp} p 要替换的模式的 RegExp 对象
   * @param {string} r 一个字符串值。规定了替换文本或生成替换文本的函数。
   * @example
   *          this.commonReplace(str + "", this.RegExps.trim, '');
   * @returns {string} 处理结果
   */
  commonReplace: function commonReplace(s, p, r) {
    return s.replace(p, r);
  },

  /**
   * 通用系列替换
   *
   * @ignore
   * @param {string} s 需要进行替换的字符串
   * @param {Object} l RegExp对象hashMap
   * @example
   *          this.listReplace(str,regHashmap);
   * @returns {string} 处理结果
   */
  listReplace: function listReplace(s, l) {
    if (this.isHashMap(l)) {
      for (var i in l) {
        s = this.commonReplace(s, l[i], i);
      }

      return s;
    } else {
      return "".concat(s);
    }
  },

  /**
   * 制造html中换行符
   *
   * @param {string} str 目标字符串
   * @example
   *          this.nl2br(str);
   * @returns {string} 结果
   */
  nl2br: function nl2br(str) {
    return this.commonReplace("".concat(str), this.RegExps.nl2br, '<br />');
  },

  /**
   * 制造html中空格符，爽替换
   *
   * @param {string} str 目标字符串
   * @example
   *          this.s2nb(str);
   * @returns {string} 结果
   */
  s2nb: function s2nb(str) {
    return this.commonReplace("".concat(str), this.RegExps.s2nb, '&nbsp;&nbsp;');
  },

  /**
   * htmlEscape
   *
   * @param {string} str 目标串
   * @example
   *          this.escHTML(str);
   * @returns {string} 结果
   */
  escHTML: function escHTML(str) {
    var t = this.RegExps.escHTML;
    return this.listReplace("".concat(str), {
      /*
       * '&' must be
       * escape first
       */
      '&amp;': t.re_amp,
      '&lt;': t.re_lt,
      '&gt;': t.re_gt,
      '&#039;': t.re_apos,
      '&quot;': t.re_quot
    });
  },

  /**
   * xhtmlEscape还原
   *
   * @param {string} str 目标串
   * @returns {string} 结果
   */
  restHTML: function restHTML(str) {
    var t = this.RegExps.restHTML;
    return this.listReplace("".concat(str), {
      /*
       * '&' must be
       * escape last
       */
      '<': t.re_lt,
      '>': t.re_gt,
      '\x27': t.re_apos,
      '\x22': t.re_quot,
      '&': t.re_amp
    });
  },

  /**
   * 是否哈希表结构
   *
   * @param {object} o 目标
   * @returns {boolean} 结果
   * @example QZFL.lang.isHashMap(obj);
   */
  isHashMap: function isHashMap(o) {
    return this.getType(o) === 'object';
  },

  /**
   * 获取对象类型
   *
   * @param {object} obj 任意一个数据
   * @return {string} 返回对象类型字符串
     * @example
   * QZFL.object.getType([1,2,3]);
   */
  getType: function getType(obj) {
    return obj === null ? 'null' : obj === undefined ? 'undefined' : Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
  },

  /**
   * 动态加载JS文件
   * @param  {[type]}   id       [description]
   * @param  {[type]}   url      [description]
   * @param  {Function} callback [description]
   * @return {[type]}            [description]
   */
  loadScript: function loadScript(id, url, callback) {
    var target = document.getElementById(id);

    if (target) {
      callback && callback();
    } else {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = id;
      script.src = url;

      script.onload = script.onreadystatechange = function () {
        if (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete') {
          callback && callback();
        }
      };

      script.src = url;
      var head = document.getElementsByTagName('head')[0];
      head.appendChild(script);
    }
  },

  /**
   * 获取平台
   * @return {[type]} [description]
   */
  getPlat: function getPlat() {
    var data = {
      plat: 0,
      channel: 0
    };
    var ua = navigator.userAgent;

    if (ua.indexOf('Android') !== -1) {
      data.plat = 108;
    } else if (ua.indexOf('iPhone') !== -1) {
      data.plat = 107;
    } else if (ua.indexOf('iPad') !== -1) {
      data.plat = 105;
    }

    if (ua.indexOf('MicroMessenger') !== -1) {
      var from = this.getUrlParam('from');

      if (from === 'timeline') {
        data.channel = 8;
      } else {
        data.channel = 16;
      }
    } else if (ua.indexOf('TXMicroBlog') !== -1) {
      data.channel = 1;
    } else if (ua.indexOf('Weibo') !== -1) {
      data.channel = 4;
    } else if (/ QQ\//.test(ua)) {
      data.channel = 64;
    } else if (/ Qzone\//.test(ua)) {
      data.channel = 2;
    }
    /*
     else if (ua.indexOf('QQLiveBrowser') != -1) {
     data.channel = 128;
     }
     */


    return data;
  },
  date: {
    format: function () {
      var fnMap = {
        Y: function Y(d) {
          return d.getFullYear();
        },
        m: function m(d) {
          return pad(d.getMonth() + 1);
        },
        n: function n(d) {
          return d.getMonth() + 1;
        },
        d: function d(_d) {
          return pad(_d.getDate());
        },
        e: function e(d) {
          return d.getDate();
        },
        H: function H(d) {
          return pad(d.getHours());
        },
        i: function i(d) {
          return pad(d.getMinutes());
        },
        s: function s(d) {
          return pad(d.getSeconds());
        }
      };
      var pattern = Object.keys ? Object.keys(fnMap).join('') : function () {
        var k;
        var r = '';

        for (k in fnMap) {
          r += k;
        }

        return r;
      }();
      var patternRegExp = new RegExp("[".concat(pattern, "]"), 'g');

      function pad(n) {
        return n > 9 ? n : "0".concat(n);
      }
      /**
       *@param date Date|Integer|String:'YYYY-MM-DD hh:ii:ss'|String:/^\d+$/
       *@return String
       */


      return function (date, format) {
        var dateObj;

        if (/^\d+$/.test(date)) {
          dateObj = new Date(parseInt(date));
        } else if (typeof date === 'string') {
          dateObj = new Date(date.replace(/-/g, '/'));
        } else if (Object.prototype.toString.call(date) === '[object Date]') {
          dateObj = date;
        }

        if (!dateObj || dateObj.toString() === 'Invalid Date') {
          throw new Error("[hlw.date.format]the input cannot be converted to date object(".concat(date, ")"));
        }

        return format.replace(patternRegExp, function (k) {
          if (typeof fnMap[k] === 'function') {
            return fnMap[k](dateObj);
          }

          return k;
        });
      };
    }()
  },

  /**
   * 设置localStorage缓存
   * @param key
   * @param data
   */
  setCache: function setCache(key, data) {
    if (localStorage) {
      localStorage.setItem(key, JSON.stringify(data));
    }
  },

  /**
   * 清除localStorage缓存
   * @param key
   * @returns {*}
   */
  getCache: function getCache(key) {
    var value;

    if (localStorage) {
      try {
        value = localStorage.getItem(key);

        if (value != null) {
          value = JSON.parse(value);
        }
      } catch (e) {
        void 0;
      }
    }

    return value;
  },

  /**
   * 获取用户相关的localStorage缓存
   * @param key
   * @return {*}
   */
  getUserCache: function getUserCache(key) {
    return this.getCache(getUserid() + key);
  },

  /**
   * 设置用户相关的localStorage缓存
   * @param key
   * @param data
   * @return {*}
   */
  setUserCache: function setUserCache(key, data) {
    return this.setCache(getUserid() + key, data);
  },
  isThenable: function isThenable(o) {
    return _typeof(o) === 'object' && o.then && o.catch && typeof o.then === 'function' && typeof o.catch === 'function';
  },

  /**
   * 当电脑访问时跳转到一个带二维码的web页面
   * @param qrCodePicUrl 二维码地址
   * @param pageTitle 页面标题
   * @param pagePic 页面示例图
   * @param pageDesc 二维码下方描述
   * @param pageUrl 二维码对应的跳转地址
   */
  webQrCode: function webQrCode(_ref) {
    var qrCodePicUrl = _ref.qrCodePicUrl,
        _ref$pageTitle = _ref.pageTitle,
        pageTitle = _ref$pageTitle === void 0 ? document.title : _ref$pageTitle,
        _ref$pagePic = _ref.pagePic,
        pagePic = _ref$pagePic === void 0 ? '' : _ref$pagePic,
        _ref$pageDesc = _ref.pageDesc,
        pageDesc = _ref$pageDesc === void 0 ? '' : _ref$pageDesc,
        _ref$pageUrl = _ref.pageUrl,
        pageUrl = _ref$pageUrl === void 0 ? location.href : _ref$pageUrl;
    var isWeb = env.isWin || env.isMac && !env.isIphone && !env.isIpad && !env.isAndroid;

    if (isWeb) {
      window.location.href = "//film.qq.com/weixin/v3/web-to-phone/index.html?url=".concat(encodeURIComponent(pageUrl), "&desc=").concat(encodeURIComponent(pageDesc), "&pic=").concat(encodeURIComponent(pagePic), "&title=").concat(encodeURIComponent(pageTitle), "&qrcode=").concat(encodeURIComponent(qrCodePicUrl));
    }
  },

  /**
   * 生成二维码链接
   * @param url 链接地址或urlparam对象或空
   */
  genQrCodeUrl: function genQrCodeUrl(url) {
    var isNeedShort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    var base = '//pay.video.qq.com/fcgi-bin/qrencode';

    if (typeof url === 'string') {
      base = this.setUrlParam('url', url, base);
      base = this.setUrlParam('isNeedShort', isNeedShort, base);
      base = this.setUrlParam('margin', margin, base);
      return base;
    } else if (_typeof(url) === 'object') {
      for (var key in url) {
        base = this.setUrlParam(key, url[key], base);
      }

      return base;
    } else {
      return this.genQrCodeUrl(location.href);
    }
  },

  /**
   * 昵称隐藏打点
   * @param {String} nickname 昵称
   * @param {String} defaultNick 为空时默认昵称
   */
  hideNick: function hideNick(nickname) {
    var defaultNick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!nickname) {
      return defaultNick;
    }

    var nickArr = Array.from(nickname);
    if (nickArr.length === 1) return '*';
    if (nickArr.length === 2) return nickArr[0] + '*';

    if (nickArr.length === 3) {
      return nickArr[0] + '*' + nickArr[nickArr.length - 1];
    }

    return nickArr[0] + '**' + nickArr[nickArr.length - 1];
  },

  /**
   * 格式化超长数字
   * @param {Number} value
   */
  formatNum: function formatNum(value) {
    if (+value < 1e4) {
      return value;
    } else if (value < 1e5) {
      return parseInt(value / 1e2) / 100 + 'w';
    } else if (value < 1e6) {
      return parseInt(value / 1e3) / 10 + 'w';
    } else if (+value < 1e8) {
      return "".concat(Math.floor(+value / 1e4), "w");
    } else {
      return "".concat(Math.floor(+value / 1e6) / 10, "kw");
    }
  }
};